module.exports = __webpack_public_path__ + "static/media/dine-in-black.c32e1cdd.svg";